import {ChangeEvent} from "react";
import classNames from "classnames";
import {TextField} from "@mui/material";
import styles from "./RangeInput.module.scss";

type Props = {
    value: {
        min: number;
        max: number;
    };
    loading?: boolean;
    minLabel?: string;
    maxLabel?: string;
    onChange: (
        value: {
            min: number;
            max: number;
        }
    ) => void;
    onBlur?: (
        field: "min" | "max"
    ) => void;
};

export const RangeInput = (
    {
        value,
        loading = false,
        minLabel = "От",
        maxLabel = "До",
        onChange,
        onBlur,
    }: Props
) => {
    const handleChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        field: "min" | "max",
    ) => {
        const nextValue = Number(event.target.value);

        onChange({
            ...value,
            [field]: nextValue,
        });
    };

    return (
        <div className={classNames(styles.fields, {[styles.loading]: loading})}>
            <TextField
                label={minLabel}
                value={value.min}
                onChange={(event) => handleChange(event, "min")}
                onBlur={() => onBlur?.("min")}
            />
            <TextField
                label={maxLabel}
                value={value.max}
                onChange={(event) => handleChange(event, "max")}
                onBlur={() => onBlur?.("max")}
            />
        </div>
    );
};
